import { QuantityGetDto } from 'svila-common';
import { StockTransactionAddDto } from '../StockTransactionAddDto';

export const quantityGetDtoToStockTransactionAddDto = (quantity: QuantityGetDto): StockTransactionAddDto => {
  const stock: StockTransactionAddDto = {
    genericProductId: quantity.product.genericProductId,
    manufacturerId: quantity.manufacturer?.id ?? null,
    supplierId: quantity.supplier?.id ?? null,
    accountedPrice: quantity.accountedPrice,
    accountedValue: quantity.accountedValue,
    sellOrderId: quantity.sellOrder?.id ?? null,
    purchaseOrderId: quantity.purchaseOrder?.id ?? null,
    condition: quantity.condition,
    status: quantity.status,
    singleCuUnits: quantity.singleCuUnits,
    singleDpUnits: quantity.singleDpUnits,
    fullDuUnits: quantity.fullDuUnits,
    expirationDate: quantity.expirationDate,
    productionDate: quantity.productionDate,
    lot: quantity.lot,
    chamberNumber: quantity?.warehouseLocation?.warehouseChamber?.number ?? null,
    column: quantity?.warehouseLocation?.column ?? null,
    letter: quantity?.warehouseLocation?.letter ?? null,
    level: quantity?.warehouseLocation?.level ?? null,
    movementType: quantity.movementType,
    createdOn: null,
    isInvoiced: quantity.isInvoiced,
    isRemoved: quantity.isRemoved,
    notes: null,
    transactionDateTime: null,
    warehouseOwnerId: quantity?.warehouseOwner?.id ?? null,
    warehouseId: quantity?.warehouse?.id ?? null,
  };

  return stock;
};